var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25936 0.98584C2.81113 0.98584 0.00585938 3.79704 0.00585938 7.25248C0.00585938 12.809 5.63286 17.182 5.87243 17.3656L6.2594 17.6619L6.64612 17.3656C6.88569 17.182 12.5129 12.809 12.5129 7.25248C12.5129 3.797 9.70763 0.98584 6.25936 0.98584ZM6.2589 16.03C5.02642 14.9672 1.28 11.3946 1.28 7.25248C1.28 4.50101 3.51342 2.26266 6.25936 2.26266C9.00481 2.26266 11.2387 4.50105 11.2387 7.25248C11.2388 11.3857 7.49085 14.9655 6.2589 16.03Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37121 10.3662C4.66043 10.3662 3.26855 8.97449 3.26855 7.26379C3.26855 5.553 4.66038 4.16113 6.37121 4.16113C8.082 4.16113 9.47382 5.55296 9.47382 7.26379C9.47382 8.97449 8.082 10.3662 6.37121 10.3662ZM6.37121 5.17866C5.22146 5.17866 4.28604 6.11408 4.28604 7.26383C4.28604 8.41345 5.22146 9.34874 6.37121 9.34874C7.52092 9.34874 8.45634 8.41345 8.45634 7.26383C8.45634 6.11403 7.52097 5.17866 6.37121 5.17866Z",
    fill: "#757575"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.bce1a265ca8fd582054d37c326de41b2.svg";
export { ForwardRef as ReactComponent };